import { Link } from 'react-router-dom';

const EventsPreview = () => {
  const events = [
    {
      day: 'Tuesday',
      title: 'Jam Night during High Season',
      description: 'Call to confirm schedule. Live music jam sessions with local musicians. Bring your instrument or just enjoy the show!',
      icon: 'ri-music-2-line',
      color: 'from-blue-600 to-cyan-500',
    },
    {
      day: 'Wednesday',
      title: 'Flip Night w/ Karaoke',
      description: 'Flip a coin for a free drink! Sing your heart out with karaoke all night long. 8pm to close.',
      icon: 'ri-music-2-line',
      color: 'from-purple-600 to-pink-500',
    },
    {
      day: 'Thursday',
      title: 'Steak Night',
      description: 'Premium steaks grilled to perfection. A local favorite for over 20 years!',
      icon: 'ri-restaurant-line',
      color: 'from-red-600 to-orange-500',
    },
    {
      day: 'Sunday',
      title: 'Live Music After Football Season',
      description: 'Relax with live acoustic performances and ocean views every Sunday afternoon.',
      icon: 'ri-guitar-line',
      color: 'from-blue-600 to-cyan-500',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 font-serif">
            Weekly Events & Entertainment
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Join us for live music, special dinners, and authentic Keys entertainment throughout the week
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {events.map((event, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transform hover:-translate-y-2 transition-all duration-300"
            >
              <div className={`h-2 bg-gradient-to-r ${event.color}`}></div>
              <div className="p-8">
                <div className={`w-16 h-16 bg-gradient-to-br ${event.color} rounded-2xl flex items-center justify-center mb-6`}>
                  <i className={`${event.icon} text-3xl text-white`}></i>
                </div>
                <div className="mb-2">
                  <span className="text-sm font-semibold text-slate-500 uppercase tracking-wider">
                    Every {event.day}
                  </span>
                </div>
                <h3 className="text-2xl font-bold text-slate-900 mb-3">{event.title}</h3>
                <p className="text-slate-600 leading-relaxed">{event.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/events"
            className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg font-semibold text-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            View All Events
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default EventsPreview;
